module.exports = __webpack_public_path__ + "media/hero.21b1eb0a.jpg";